import "./Home.css";


function Home(props) {
  return (
   
      <div className="homepage-content">
        <h1 className="typewriter">Hello World! I am a Software Engineer</h1>
     </div>
  
  )
}
export default Home;


